<div class="card mb-3">
  <div #tgt id="filterBody" class="card-body">
    <div class="row row-cols-lg-auto align-items-end">
      <div class="col-12">
        <div class="mb-2">{{ dateFilterVerbiage }}: <small>(default is current {{duration}} days)</small></div>
        <div>
          <label for="irStartDate" class="me-3"> 
            From:
            <p-calendar #from [(ngModel)]="startDate" inputId="irStartDate" [showIcon]="true" [yearRange]="yearRange" [monthNavigator]="true" [yearNavigator]="true" selectionMode="single" styleClass="mb-3" inputStyleClass="form-control" ></p-calendar>
          </label>
          <label for="irEndDate" class="me-3">
            To:
            <p-calendar #to [(ngModel)]="endDate" inputId="irEndDate" [showIcon]="true" [yearRange]="yearRange" [monthNavigator]="true" [yearNavigator]="true" selectionMode="single" styleClass="mb-3" inputStyleClass="form-control" ></p-calendar>
          </label>
        </div>
      </div>
      <div *ngIf="cgicCode !== '' && cgicCode != null" class="col-12">
        <label class="form-label" for="fieldDivisions">Filter by field division:</label>
        <select id="fieldDivisions" [(ngModel)]="cgicCode" class="form-select w-auto mb-3">
          <option value="all">All field divisions</option>
          <option *ngFor="let fieldDiv of fieldDivisions$ | async" value="{{fieldDiv.ENESS_REF_NIBINCGICCodes?.OrganizationCode}}">{{fieldDiv.FieldDivisionName}}</option>
        </select>
      </div>
    </div>
    <button type="button" class="btn btn-success" [disabled]="disableButton" [attr.aria-disabled]="disableButton" (click)="applyFilters()">Apply filters</button>
  </div>
</div>
